import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Toast } from 'vant';

Vue.prototype.$pureAxios = axios.create(); // 挂载一个纯净axios
Vue.use(VueAxios, axios);

const httpRequestSuccess = (request: AxiosRequestConfig) => {
  const token = localStorage.getItem('qw_token_sms');
  if (token) {
    request.headers['token'] = token;
  }
  return request;
};
const httpRequestError = (error: any) => {
  return Promise.reject(error);
};

const httpResponseSuccess = (response: AxiosResponse) => {
  Toast.clear();
  if (window.location.href.indexOf('apesk') !== -1) {
    return response.data;
  }
  if (response.data.code === 401) {
    window.location.href =
      '/cooperation/hwt/login?callback=' +
      encodeURIComponent(window.location.href);
  } else if (response.data.code !== 0 && response.data.code !== 200) {
    if (response.data.msg) {
      Toast(response.data.msg);
    } else if (response.data.msg) {
      Toast(response.data.msg);
    }
  }
  return response.data;
};

const httpResponseError = (error: any) => {
  return Promise.reject(error);
};

// axios.defaults.withCredentials = false;
axios.defaults.headers.platform = 'we_mobile';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.validateStatus = function(status) {
  return (status >= 200 && status < 300) || status == 700;
};

export const createHttp = (config: AxiosRequestConfig = {}) => {
  const httpInstance = axios.create(config);
  httpInstance.interceptors.request.use(httpRequestSuccess, httpRequestError);
  httpInstance.interceptors.response.use(
    httpResponseSuccess,
    httpResponseError
  );
  const _get = httpInstance.get;
  httpInstance.get = (
    url: string,
    params?: any,
    config: AxiosRequestConfig = {}
  ) => {
    return _get(url, { params, ...config });
  };
  return httpInstance;
};
